import { fetchArticleUsers } from 'hooks/queries/articles/users/useArticleUsers'
import { ReviewerRole, ReviewType } from './types'
import { ReviewTypeConfig } from './reviewConfig'
import { toUserValue } from './util'
import { Access, ArticleFlat, Permission, SettingsMember } from 'types'
import { type MemberFilter } from './machine'

const reviewerPermissionDefaults = (type: ReviewType): Access[] => {
  switch (type) {
    case ReviewType.APPROVAL:
      return []
    case ReviewType.SUGGESTIONS:
      return []
    case ReviewType.READ_RECEIPTS:
      return [Permission.Edit, Permission.Comment, Permission.Read]
    default:
      return [Permission.Edit]
  }
}

export const reviewerRoleDefault = (type: ReviewType): ReviewerRole | null => {
  switch (type) {
    case ReviewType.APPROVAL:
      return ReviewerRole.APPROVER
    case ReviewType.SUGGESTIONS:
      return null
    case ReviewType.READ_RECEIPTS:
      return ReviewerRole.VIEWER
    default:
      return ReviewerRole.REVIEWER
  }
}

type FetchReviewTypeArgs = {
  articleId: ArticleFlat['id'] | null
  reviewType: ReviewType
  isNotSelf: MemberFilter
}

export const fetchReviewTypeConfig = async ({
  articleId,
  reviewType,
  isNotSelf,
}: FetchReviewTypeArgs): Promise<ReviewTypeConfig> => {
  if (articleId === null) return Promise.resolve({ approvers: [], reviewers: [] })

  const permissions = reviewerPermissionDefaults(reviewType)
  const viewerMembers = await fetchArticleUsers(articleId, permissions)
  const roleDefault = reviewerRoleDefault(reviewType)

  return reviewersFromRole(roleDefault, viewerMembers, isNotSelf)
}

function reviewersFromRole(roleDefault: ReviewerRole | null, viewerMembers: SettingsMember[], isNotSelf: MemberFilter) {
  switch (roleDefault) {
    case ReviewerRole.VIEWER:
      return { approvers: [], reviewers: [], viewers: viewerMembers.filter(isNotSelf).map(toUserValue) }
    default:
      return { approvers: [], reviewers: [] }
  }
}
